import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en.json";
import de from "./locales/de.json";
import el from "./locales/el.json";
import { DEFAULT_LANG } from "./locales";

// Single shared i18next instance. The active language is driven by the URL
// prefix via <LocaleLayout>, not by a browser-language detector, so that
// prerendered snapshots are deterministic per route.
i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    de: { translation: de },
    el: { translation: el },
  },
  lng: DEFAULT_LANG,
  fallbackLng: DEFAULT_LANG,
  interpolation: { escapeValue: false },
  returnNull: false,
});

export default i18n;
